import { sendToInsight } from '../actions/commerce-business-branch-actions.mjs';
import { usePages, useUser, useDispatch, notifyError } from '@ignitesales/neuro-application/src/neuro-guide';

const useSendToInsight = (lookupInfo, setLoading) => {
  const dispatch = useDispatch();
  const { uuid, getEmployee } = useUser();
  const { paths } = usePages();

  const getQuestionsOrder = () => {
    const questionAppKeys = [];
    paths.forEach(entry => {
      entry.pages.forEach(page => {
        questionAppKeys.push(...page.questions);
      });
    });
    return questionAppKeys;
  };

  const hasSentToInsight = JSON.parse(window.sessionStorage.getItem(`${uuid}_sendToInsight`))?.isSubmitted;

  const onSendToInsightClicked = () => {
    const missingCompanyInfo = !(lookupInfo.company || lookupInfo.contact);
    if (missingCompanyInfo) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      notifyError('summary.sendToInsight.noInfo');
    } else {
      const data = lookupInfo.company || lookupInfo.contact;
      const lead = {
        email: data?.email,
        firstName: data?.firstName,
        lastName: data?.lastName,
        phone: data?.contactPhone,
        businessName: data?.companyName || 'N/A'
      };
      const questionsOrder = getQuestionsOrder();
      dispatch(sendToInsight(lead, uuid, getEmployee(), data, setLoading, questionsOrder));
    }
  };

  return { hasSentToInsight, onSendToInsightClicked };
};

export default useSendToInsight;
